import {
  Auth,
  CognitoHostedUIIdentityProvider,
  CognitoUser,
} from '@aws-amplify/auth'
import { HubPayload } from '@aws-amplify/core'
import { configure } from './aws-exports'

export type AuthEvent =
  | {
      event: 'signIn'
    }
  | {
      event: 'signIn_failure'
      data: {
        message: `PreSignUp+failed${string}` | any
      }
    }
  | HubPayload

export const signIn = async (
  email: string,
  password: string,
): Promise<
  | (CognitoUser & {
      challengeName?: 'NEW_PASSWORD_REQUIRED' | 'PASSWORD_RESET_REQUIRED'
    })
  | undefined
> =>
  Auth.signIn(email, password).then(
    async (user) => user,
    (err) => {
      if (err.code === 'PasswordResetRequiredException')
        return { challengeName: 'PASSWORD_RESET_REQUIRED' }
      console.error(err)
    },
  )

export const signInWithFacebook = () =>
  Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Facebook })

export const resetPasswordRequest = async (email: string) =>
  Auth.forgotPassword(email).catch((err) => console.error(err))

export const resetPassword = async (
  email: string,
  code: string,
  newPassword: string,
) => Auth.forgotPasswordSubmit(email, code, newPassword)

export const signOut = async () => {
  return Auth.signOut({})
}

export const intialize = async () => {
  Auth.configure(configure.Auth)
  return currentIdToken()
}

export const currentIdToken = async () =>
  (await Auth.currentSession()).getIdToken().getJwtToken()

export const refreshIdToken = async () => {
  const session = await Auth.currentSession()
  const user: CognitoUser = await Auth.currentAuthenticatedUser()
  return new Promise((res) =>
    user.refreshSession(session.getRefreshToken(), async () => {
      res(await currentIdToken())
    }),
  )
}

export const newPassword = async (
  user: CognitoUser,
  password: string,
): Promise<CognitoUser | undefined> => Auth.completeNewPassword(user, password)

export const changePassword = async (
  oldPassword: string,
  newPassword: string,
) =>
  Auth.currentAuthenticatedUser().then((user) =>
    Auth.changePassword(user, oldPassword, newPassword),
  )
